import React from "react";

const Footer = () => {
  return (
    <div className="bottom-page">
      <div className="body-text">
        &copy; 2025 Sachi Product | Design & Developed by{" "}
        <a href="https://theaditech.in/" target="_blank">
          The Adi Tech
        </a>
      </div>
    </div>
  );
};

export default Footer;
